import * as actionTypes from "./actionTypes";

const adminReducer = (state = {isLoggedIn: false, isLoading: true, tps: 'baxi', admin: null}, action)=>{
    switch (action.type) {
        case actionTypes.LOADING:
            return {
                isLoading: true,
                ...state
            };
        case actionTypes.LOGGED_IN:
            return {
                isLoading: false,
                isLoggedIn: true,
                tps: state.tps,
                admin: {...action.payload}
            }
        case actionTypes.LOGGED_OUT:
            return {
                isLoading: false,
                isLoggedIn: false,
                tps: null,
                admin: null
            };
        case actionTypes.UPDATE:
            return {
                ...state,
                isLoading: false,
                admin: {
                    ...state.admin,
                    name: action.payload.name ?? state.admin.name,
                    email: action.payload.email ?? state.admin.email,
                    phonenumber: action.payload.phonenumber ?? state.admin.phonenumber
                }
            }
        case actionTypes.CHANGE_TPS:
                return {
                    ...state,
                    tps: action.payload.tps
                }
        default:
            return state;
    }
}


export default adminReducer;